import { contactContent } from '@/mocks/home';

export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-black text-foreground-950 font-heading mb-3">
            {contactContent.title}
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-[600px] mx-auto">
            {contactContent.subtitle}
          </p>
        </div>

        <div className="max-w-[900px] mx-auto">
          <div className="bg-background-50 rounded-2xl p-6 md:p-10 border border-background-200/70">
            <p className="text-foreground-700 text-sm md:text-base leading-relaxed text-center mb-8 max-w-[650px] mx-auto">
              {contactContent.desc}
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 md:gap-5">
              {contactContent.methods.map((method) => (
                <div
                  key={method.label}
                  className="bg-background-100 rounded-xl p-5 text-center border border-background-200/60"
                >
                  <div className="w-12 h-12 rounded-full bg-primary-100 flex items-center justify-center mx-auto mb-3">
                    <i className={`${method.icon} text-primary-600 text-lg w-5 h-5 flex items-center justify-center`}></i>
                  </div>
                  <div className="text-xs text-foreground-400 mb-1">{method.label}</div>
                  <div className="font-semibold text-foreground-900 text-sm break-all">{method.value}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}